/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-expressions */
import { useAuth0 } from "@auth0/auth0-react";
import SaveFilterSvgComponent from "assets/icons/svg/saveFilterSvg";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import AuthService from "Lib/API/Auth";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router";
// import { fetchProducts } from "./filterSlice";
import Button from "components/button/Button";
import InfoTooltip from "components/InfoTooltip";
import "./index.scss";

const SaveFilter = ({ openModal, closeModal, id, filters, isRunSegment }) => {
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const filterId = queryParams.get("id");
  const [filterName, setFilterName] = useState("");
  const [description, setFilterDescription] = useState("");

  const [error, setError] = useState("");
  const fieldsGroup  = useSelector(
    (state) => state?.filterParams.fieldsGroup
  );
  const {fieldsOrder,orderFieldType} = useSelector((state) => state.filterParams);


  const handleSave = async () => {
    const token = await getAccessTokenSilently();
    if (filterName) {
      const data_to_send = {
        filterName,
        isLabeled: orderFieldType === "labels-output",
        selectedFields: Object.keys(fieldsGroup).map((key) => {
          const mainArray = fieldsGroup?.[key]?.values ?? [];
          const lineIndex = 0;
          const lineContainsArray = Array.isArray(mainArray[lineIndex]);
          return {
            collectionName: fieldsGroup[key]?.collectionName || "",
            fieldName: key,
            type: fieldsGroup[key].oprInputType,
            displayName: fieldsGroup[key].displayName,
            operator: fieldsGroup[key].operator,
            fieldValue: lineContainsArray ? fieldsGroup[key].values?.[0] : fieldsGroup[key].values || [],
          };
        }),
        selectedFieldsOrder: fieldsOrder.map(
          ({ collectionName, fieldName, displayName }, index) => {
            return {
              collectionName,
              fieldName,
              order: index + 1,
              displayName,
            };
          }
        ),
      };

      const data_to_edit = {
        filterName,
        isLabeled: orderFieldType === "labels-output",
        filterId: id,
        selectedFields: Object.keys(fieldsGroup)?.length ? Object.keys(fieldsGroup).map((key) => {
          const mainArray = fieldsGroup?.[key]?.values ?? [];
          const lineIndex = 0;
          const lineContainsArray = Array.isArray(mainArray[lineIndex]);
          const hasComma = fieldsGroup[key].values?.includes(',');

          return {
            collectionName: fieldsGroup[key]?.collectionName || "",
            fieldName: key,
            operator: fieldsGroup[key].operator,
            type: fieldsGroup[key].oprInputType,
            displayName: fieldsGroup[key].displayName,
            fieldValue: lineContainsArray ? fieldsGroup[key].values?.[0] : fieldsGroup[key]?.oprInputType === "multiSelect" ? fieldsGroup[key].values?.split(" , ") : 
            fieldsGroup[key].operator === 7 || fieldsGroup[key].operator === 8 
            ? hasComma ? fieldsGroup[key]?.values?.split(' , ') : [fieldsGroup[key].values]
            : fieldsGroup[key].values || [],
          };
        }) : filters,
        selectedFieldsOrder: fieldsOrder.map(
          ({ collectionName, fieldName, displayName }, index) => {
            return {
              collectionName,
              fieldName,
              order: index + 1,
              displayName,
            };
          }
        ),
      };
      if (description !== "") {
        data_to_edit.description = description;
        data_to_send.description = description;
      }
      {
        id
          ? await AuthService.editFilter(data_to_edit, token)
          : await AuthService.sendFilterParams(data_to_send, token);
      }
      closeModal();
      history.push("/report");
    } else if (!filterName) {
      setError("Please enter Title/description");
    }
  };

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const resolvedId = filterId || id;
      if (resolvedId) {
        AuthService.getFilterById(resolvedId, token)
          .then((res) => {
            if (res?.filterName) setFilterName(res.filterName);
            if (res?.description) setFilterDescription(res.description);
          })
          .catch((err) => err);
      }
    }
    fetchMyAPI();
  }, [filterId, id, getAccessTokenSilently]);

  return (
    <MyModal className="save-filter" open={openModal} onClose={closeModal}>
      <div className="save-filter-svg">
        {/* <div className="svg-class">
          <SaveFilterSvgComponent />
        </div> */}
        <div className="save-filter-head">{isRunSegment ? "Rename Report" : "Save Report"}</div>
      </div>
      <div
        style={{
          marginLeft: "-24rem",
          marginTop: "15px",
          marginBottom: "-16px",
          fontSize: "15px",
          display: "flex",
          alignItems: "center",
        }}
      >
        Report Name
        <InfoTooltip text="This is the name shown in the segments list, so make it recognizable to your team." style={{ marginLeft: '6px' }} />
      </div>
      <input
        className="save-input"
        value={filterName}
        onChange={(e) => {
          setError("");
          setFilterName(e.target.value);
        }}
        placeholder={"Enter Report name "}
      />
      <div
        style={{
          marginLeft: "-21rem",
          marginTop: "15px",
          marginBottom: "-16px",
          fontSize: "15px",
        }}
      >
        Report Description
      </div>
      <input
        className="save-input"
        value={description}
        onChange={(e) => {
          setError("");
          setFilterDescription(e.target.value);
        }}
        placeholder={"Enter report description (optional)"}
      />
      <div className="error-message">{error}</div>
      <div className="save-button report-save-filter">
        <Button
          variant="primary"
          size="md"
          content="Save"
          style={{ minWidth: "100px" }}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </MyModal>
  );
};

export default SaveFilter;
